<template>
  <v-container class="pa-0 ma-0"
               fluid
               full-height>
  <v-row no-gutters
         class="full-height"
         v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
    <!-- inicio de sidebar -->
    <v-col cols="2" class="smartbell-sidebar pa-0 full-height hidden-sm-and-down" v-if="userData.onboarding === true">
    
    </v-col>
    <!-- fin de sidebar -->

    <v-col col="12" md="10"
    class="px-0 px-sm-6 pr-lg-12 mt-3 mb-4 full-height std-background-white-1">
      <!-- inicio mensaje exito-->
      <v-row justify="center">
          <v-dialog v-model="userSaved" persistent max-width="40%">
              <v-card>
                  <v-row align="center" justify="center">
                      <v-col cols="11">
                          <v-row class="smartbell-modalContainer">
                              <v-col cols="12" md="6" class="smartbell-modalContainerLeft">
                                  <img src="../assets/HappyCow.png" alt="">
                              </v-col>
                              <v-col cols="12" md="6" class="smartbell-modalContainerRight">
                                  <h3>Felicidades!!!</h3>
                                  <span>{{userData.firstName}} acabas de cambiar la información de tu perfil de usuario</span>
                                  <v-btn class="smartbell-greenButton smartbell-modalButton" @click="saveUserInformation()">Continuar</v-btn>
                              </v-col>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-card>
          </v-dialog>
      </v-row>
      <!-- fin mensaje exito-->

      <!-- inicio mensaje cambio contraseña-->
      <v-row justify="center">
          <v-dialog v-model="passwordSend" persistent max-width="40%">
              <v-card>
                  <v-row align="center" justify="center">
                      <v-col cols="11">
                          <v-row class="smartbell-modalContainer">
                              <v-col cols="12" md="6" class="smartbell-modalContainerLeft">
                                  <img src="../assets/HappyCow.png" alt="">
                              </v-col>
                              <v-col cols="12" md="6" class="smartbell-modalContainerRight">
                                  <h3>Felicidades!!!</h3>
                                  <span>{{userData.firstName}} hemos enviado un link para cambiar tu contraseña a tu cuenta de correo</span>
                                  <v-btn class="smartbell-greenButton smartbell-modalButton" @click="sendPasswordEmail()">Continuar</v-btn>
                              </v-col>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-card>
          </v-dialog>
      </v-row>
      <!-- fin mensaje cambio contraseña-->

      <!-- inicio perfil de usuario-->
      <v-row no-gutters
             align="center"
             justify="center"
             class="md-mb-8">
          <v-col cols="12" class="pt-0">

            <!-- inicio mensaje superior-->
            <v-row align="center" justify="center" v-if="userData.onboarding === false">
              <v-col md="10" cols="10" style="text-align: center;"
              class="ma-0 pa-0 mt-4 std-text-blue-2">
                <h2 class="std-text-lg">Aqui puedes editar la informacion de tu cuenta</h2>
              </v-col>
            </v-row>
            <!-- fin mensaje superior-->

            <!-- inicio fila superior-->
            <v-row no-gutters
                   :class="[this.$vuetify.breakpoint.smAndUp ? 'justify-space-between' : 'justify-start']"
                   class="mb-6"
                   v-if="userData.onboarding === true">

              <!-- inicio de botón de agregar vaca -->
              <v-col cols="3" class="pa-0 hidden-xs-only">
                <v-btn class="pt-2 pb-1 smartbell-blueButton button-text d-flex justify-space-between align-center"
                style="align-items: center; justify-content: center;"
                block
                depressed
                elevation="6"
                height=40px
                @click="openPageUserAdd('UserAdd')">
                  <div class="d-flex justify-space-between align-center button-text btn-text-container">
                    Agregar Usuario
                    <img class="d-flex align-center" src="../assets/icons/AddUser.png" alt="">
                  </div>
                </v-btn>
              </v-col>
              <!-- fin de botón de agregar vaca -->

              <!-- inicio de movil botón regresar -->
              <v-col cols="2" class="pa-0 hidden-sm-and-up">
                <BackButton></BackButton>
              </v-col>
              <!-- fin de movil botón regresar -->

              <!-- inicio de cambiar de rancho -->
              <v-col cols="6" sm="4" md="3" offset="1" offset-sm="0" class="pa-0">
                <ChangeRanch></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->

              <!-- inicio contador de ranchos-->
              <v-col cols="4" md="4" class="pa-0 hidden-xs-only">
                <SystemCardCount height="40px"
                                 width="100%"
                                 number="100"
                                 title-background="#57A7F5"
                                 number-background="#1460AA"
                                 title="Usuarios en Sistema">
                </SystemCardCount>
              </v-col>
              <!-- fin contador de ranchos -->
            </v-row>
            <!-- fin fila superior-->

            <!-- inicio cuerpo principal-->
            <v-row no-gutters
                   justify="center"
                   :class="{'std-content-container': $vuetify.breakpoint.mdAndUp}"
                   class="std-container-shadow std-border-radius">
              <!-- inicio barra usuario-->
              <v-col class="pa-0 std-text-lg std-text-white-1 std-background-grey-3 std-border-top-radius justify-center d-flex align-center"
                      cols="12"
                      style="height: 48px; font-weight: bold;"
                      v-if="userData.onboarding === true">
                Dueño
              </v-col>
              <!-- fin barra usuario-->
              
              <!-- inicio inputs-->
              <v-col cols="12" lg="11" class="pa-0 pt-3 px-3 px-md-6">
                <v-row no-gutters>
                  <!-- inicio componentes izquierda-->
                  <v-col cols="12" sm="8" class="order-1 order-sm-0 pl-0 pb-0 pt-3 pt-sm-0 pa-sm-3">
                    <h3 class="std-text-blue-2 hidden-xs-only" style="font-size: 1.25rem;">Datos Generales</h3>
                    <!-- inicio inputs nombre-->
                    <v-row no-gutters>
                      <v-col md="6" cols="12" class="pr-md-2">
                        <div class="col-12 std-text-md std-text-blue-2 pa-0">
                          Nombre
                        </div>
                        <v-text-field
                          v-model="userData.firstName"
                          clearable
                          dense
                          flat
                          placeholder="Don Jose Guadalupe Trinidad"
                          outlined
                          class="form-text-input"
                          required
                          :rules="nameRules"
                          :disabled="editActive"
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="6" cols="12" class="pl-md-2">
                        <div class="col-12 std-text-md std-text-blue-2 pa-0">
                          Apellidos
                        </div>
                        <v-text-field
                          v-model="userData.lastName"
                          clearable
                          dense
                          flat
                          placeholder="Lopez de la Garza Peña"
                          class="form-text-input"
                          outlined
                          required
                          :rules="lastNameRules"
                          :disabled="editActive"
                          >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- fin inputs nombre-->

                    <!-- inicio inputs contacto-->
                    <v-row no-gutters>
                      <v-col md="6" cols="12" class="pr-md-2">
                        <div class="col-12 std-text-md std-text-blue-2 pa-0">
                          Teléfono
                        </div>
                        <v-text-field
                          v-model="userData.phone"
                          clearable
                          dense
                          flat
                          placeholder="+52-347-101-5721"
                          class="form-text-input"
                          outlined
                          required
                          :rules="phoneRules"
                          :disabled="editActive"
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="6" cols="12" class="pl-md-2">
                        <div class="col-12 std-text-md std-text-blue-2 pa-0">
                          Correo Electrónico
                        </div>
                        <v-text-field
                          v-model="userData.email"
                          clearable
                          dense
                          flat
                          placeholder="gpetrino@gmail.com"
                          class="form-text-input"
                          outlined
                          required
                          :rules="emailRules"
                          :disabled="editActive"
                          >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- fin inputs contacto-->

                    <!-- inicio cambio contraseña-->
                    <v-row no-gutters class="pb-0">
                      <v-col cols="12" class="py-0">
                        <span class="std-text-underline"
                              style="color: var(--smartbell-grey-light-3);"
                              @click="openSendPasswordEmail()"
                              v-bind:class="{ 'std-text-underline std-text-blue-2': saveActive }">
                          Cambiar contraseña
                        </span><br>
                        <span style="font-size:11px;">
                          Recomendación usa una contraseña segura que no uses en ningún otro sitio
                        </span>
                      </v-col>
                    </v-row>
                    <!-- fin cambio contraseña-->

                    <!-- inicio movil botones inferiores-->
                    <v-row no-gutters justify="center" class="py-6 hidden-sm-and-up">
                      <v-col cols="6" class="d-flex justify-end pa-0 pr-4">
                        <v-btn text class="UserProfile-controlButton UserProfile-disabledBottom smartbell-buttonCorrection"
                               v-bind:class="{ 'smartbell-blueButton': editActive }"
                               @click="activateEdit()">
                          Editar <v-icon class="ml-3">create</v-icon></v-btn>
                      </v-col>
                      
                      <v-col cols="6" class="d-flex justify-start pa-0 pr-4">
                        <v-btn text class="UserProfile-controlButton UserProfile-disabledBottom smartbell-buttonCorrection" v-bind:class="{ 'smartbell-greenButton': saveActive }" @click="openSaveUserInformation()">
                          Guardar <v-icon class="ml-3">save</v-icon></v-btn>
                      </v-col>
                    </v-row>
                    <!-- fin movil botones inferiores-->

                    <!-- inicio alertas-->
                    <v-row no-gutters class="pb-0" v-if="userData.onboarding === true">
                      <!-- inicio texto superior-->
                      <v-col cols="12" class="pb-0 ma-0 pb-0 std-text-blue-2">
                        <h3 style="font-size: 1.25rem;">Alertas Activas</h3>
                      </v-col>
                      <!-- fin texto superior-->

                      <!-- inicio botones alertas-->
                      
                      <!-- inicio alerta email-->
                      <v-col cols="6" lg="4" class="py-2 pr-2">
                        <div class="UserProfile-singleAlert" v-bind:class="{ 'std-blue-btn': mailActive }">
                          <div class="UserProfile-sigleAlertLeft">
                              <img src="../assets/EmailSmall.svg" alt=""> <span>Email</span>
                          </div>
                          <div class="UserProfile-sigleAlertRight">
                            <v-checkbox class="pa-0 ma-0"
                                        v-model="mailActive"
                                        color="white"
                                        hide-details>
                          </v-checkbox>
                          </div>
                        </div>
                      </v-col>
                      <!-- fin alerta email-->

                      <!-- inicio alerta notificacion-->
                      <v-col cols="6" lg="4" class="py-2 pl-2 mr-lg-1">
                        <div class="UserProfile-singleAlert" v-bind:class="{ 'std-blue-btn': notificationActive}">
                          <div class="UserProfile-sigleAlertLeft">
                              <img src="../assets/MobileAlertSmall.svg" alt=""> <span>Notificación</span>
                          </div>
                          <div class="UserProfile-sigleAlertRight">
                            <v-checkbox class="pa-0 ma-0" v-model="notificationActive" color="white" hide-details></v-checkbox>
                          </div>
                        </div>
                      </v-col>
                      <!-- fin alerta notificacion-->

                      <!-- inicio alerta web-->
                      <v-col cols="6" lg="4" class="py-2 pr-2">
                        <div class="UserProfile-singleAlert" v-bind:class="{ 'std-blue-btn': webActive }">
                          <div class="UserProfile-sigleAlertLeft">
                              <img src="../assets/WebAlertSmall.svg" alt=""> <span>Alerta Web</span>
                          </div>
                          <div class="UserProfile-sigleAlertRight">
                            <v-checkbox class="pa-0 ma-0" v-model="webActive" color="white" hide-details></v-checkbox>
                          </div>
                        </div>
                      </v-col>
                      <!-- fin alerta web-->

                      <!-- inicio alerta SMS-->
                      <v-col cols="6" lg="4" class="py-2 pl-2">
                        <div class="UserProfile-singleAlert" v-bind:class="{ 'std-blue-btn': smsActive }">
                          <div class="UserProfile-sigleAlertLeft">
                              <img src="../assets/SMSSmall.svg" alt=""> <span>SMS</span>
                          </div>
                          <div class="UserProfile-sigleAlertRight">
                            <v-checkbox class="pa-0 ma-0" v-model="smsActive" color="white" hide-details></v-checkbox>
                          </div>
                        </div>
                      </v-col>
                      <!-- fin alerta SMS-->
                        
                      <!-- fin botones alertas-->
                    </v-row>
                    <!-- fin alertas-->

                    <!-- inicio movil medidor plan-->
                    <v-row no-gutters
                           v-if="userData.onboarding === true"
                           class="hidden-sm-and-up justify-center">
                      <v-col cols="12" class="pa-0 justify-center">
                        <v-row no-gutters class="pb-0">
                            <h3 class="pb-0 pt-8 std-text-blue-1 std-text-underline"
                            style="font-size: 1.25rem; cursor: pointer;"
                            @click="openPageUserPlan('UserPlan')">
                              Plan Activo
                            </h3>
                        </v-row>
                        <v-row no-gutters>
                            <v-progress-linear
                              :active="true"
                              :background-opacity=".3"
                              :rounded="true"
                              :value="95"
                              color="#FF006A"
                            ></v-progress-linear>
                            <p class="std-text-red-1 mt-2 mb-0">
                              Llevas <strong>45 vacas</strong> de 50
                            </p>
                        </v-row>
                        <v-row no-gutters class="py-6 justify-center">
                            <v-btn text
                            @click="openPageUserType('UserType')"
                            style="width: 192px;"
                            class="smartbell-greenButton smartbell-buttonCorrection">
                              Mejora tu Plan
                            </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                    <!-- fin movil medidor plan-->
                  </v-col>
                  <!-- inicio componentes izquierda-->

                  <!-- inicio componentes derecha-->
                  <v-col cols="12" sm="4" justify="center"
                          class="order-sm-1 justify-center align-center px-0 pb-0" >
                    <!-- inicio foto perfil-->
                    <v-row no-gutters class="justify-center">
                      <img class="std-container-shadow"
                            style="width: 192px; height: 192px;"
                            src="../assets/FarmerImage.png" alt="">
                    </v-row>
                    <!-- fin foto perfil-->

                    <!-- inicio btn foto-->
                    <v-row no-gutters class="justify-center">
                      <v-col cols="12" class="pt-1 d-flex justify-center">
                        <v-btn text v-on="on"
                                    class="UserProfile-imageButton smartbell-blueButton smartbell-buttonCorrection">
                              Agregar Foto
                              <img class="UserProfile-buttonIcon ml-3"
                                    src="../assets/photoIcon.png" alt="">
                            </v-btn>
                        <v-dialog v-model="dialog" width="780px">
                          <template v-slot:activator="{ on }" class="align-center justify-center">
                            
                          </template>
                          <!-- inicio carta subir foto-->
                          <v-card>
                            <v-col cols=12>
                              <v-row no-gutters class="std-text-md std-text-blue-2 align-center justify-center"
                              style="font-size: 1.25rem;">
                                Cambia tu foto de perfil
                              </v-row>

                              <v-row no-gutters class="pa-2 px-12">
                                <v-col cols=12 class="py-6 std-border-radius"
                                style="border-style: dashed; border-color: #1460AA;">
                                  <v-row class="align-center justify-center std-text-md std-text-blue-2">
                                    <v-col style="text-align: center;">Arrasta tu archivo<b> aquí </b>
                                      <br>o<br>
                                      usa el <b>explorador</b>
                                    </v-col>
                                  </v-row>
                                </v-col>

                                <v-col cols=12 class="pa-0 pt-2 std-text-xss std-text-blue-2" style="text-align: end;">
                                  Tamaño maximo de archivo <b>2MB</b>
                                </v-col>

                                <v-col cols=3 offset=9 class="pa-0 pt-2">
                                  <v-btn style="background-color: #65D9AC !important;"
                                          class="std-text-btn font-weight-bold"
                                          elevation="3"
                                          width="100%">
                                    Guardar foto
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>


                          </v-card>
                          <!-- fin carta subir foto-->
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <!-- fin btn foto-->

                    <!-- inicio medidor plan-->
                    <v-row no-gutters
                           v-if="userData.onboarding === true"
                           class="hidden-xs-only justify-center">
                      <v-col cols="12" class="pa-0 justify-center">
                        <v-row no-gutters class="pb-0 justify-center">
                            <h3 class="pb-0 pt-8 std-text-blue-1 std-text-underline"
                            style="font-size: 1.25rem; cursor: pointer; width: 187px;"
                            @click="openPageUserPlan('UserPlan')">
                              Plan Activo
                            </h3>
                        </v-row>
                        <v-row no-gutters
                               class="justify-center">
                            <v-progress-linear
                              :active="true"
                              :background-opacity=".3"
                              :rounded="true"
                              :value="95"
                              color="#FF006A"
                              style="width: 187px;"
                            ></v-progress-linear>
                            <p class="std-text-red-1 mt-2 mb-0"
                               style="width: 187px;">
                              Llevas <strong>45 vacas</strong> de 50
                            </p>
                        </v-row>
                        <v-row no-gutters class="pt-3 justify-center">
                            <v-btn text
                            @click="openPageUserType('UserType')"
                            style="width: 192px;"
                            class="smartbell-greenButton smartbell-buttonCorrection">
                              Mejora tu Plan
                            </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                    <!-- fin medidor plan-->
                  </v-col>
                  <!-- fin componentes derecha-->
                </v-row>
              </v-col>
              <!-- fin inputs-->

              <!-- inicio botones inferiores-->
              <v-col cols="12" class="hidden-xs-only pa-0 pb-3">
                <v-row no-gutters justify="center">
                  <v-col cols="5" class="d-flex justify-end pa-0 pr-4">
                    <v-btn text class="std-btn UserProfile-controlButton UserProfile-disabledBottom smartbell-buttonCorrection"
                           v-bind:class="{ 'smartbell-blueButton': editActive }"
                           @click="activateEdit()">
                      Editar <v-icon class="ml-3">create</v-icon></v-btn>
                  </v-col>
                  
                  <v-col cols="5" class="d-flex justify-start pa-0 pr-4">
                    <v-btn text class="UserProfile-controlButton UserProfile-disabledBottom smartbell-buttonCorrection"
                    v-bind:class="{ 'smartbell-greenButton': saveActive }"
                    @click="openSaveUserInformation()">
                      Guardar <v-icon class="ml-3">save</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin botones inferiores-->
            </v-row>
            <!-- fin cuerpo principal-->

            <!-- inicio controles inferiores-->
            <v-row justify="center" class="pb-0" v-if="userData.onboarding === false">
              <v-col md="10" cols="10">
                <v-row justify="center">
                  <v-col md="4" cols="6" class="pb-0" style="text-align: right;" offset-md="4">
                    <img src="../assets/OmitirPaso.png" @click="openSectionOnboarding('DashHome')" alt="">
                  </v-col>
                  <v-col md="4" cols="6" class="pb-0" style="text-align: right;">
                    <img src="../assets/BotonContinuar.png" alt="">
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- fin controles inferiores-->
          </v-col>
      </v-row>
      <!-- fin perfil de usuario-->

      <v-footer color="#F9FDFE" padless class="smartbell-footer hidden-sm-and-down">
          <v-row justify="center" no-gutters>
              <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
              </v-col>
          </v-row>
      </v-footer>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue';
import { EventBus } from '@/views/bus.js';
import SystemCardCount from "../components/SystemCardCount";
import ChangeRanch from '@/components/ChangeRanch.vue';
import BackButton from '@/components/BackButton.vue';
export default {
  name: 'UserProfile',
    data () {
      return {
        userProfile:{
          name: '',
          lastName:'',
          phone: '',
          email: ''
        },
        editActive:true,
        saveActive:false,
        userSaved:false,
        passwordSend: false,
        mailActive:true,
        smsActive:false,
        webActive:false,
        notificationActive:false,
        userTypeCowsStatus: 0,
        nameRules: [
          v => !!v || 'Nombre requerido',
          v => /^[ñÑáéíóúÁÉÍÓÚaa-zA-Z0-9_]+((\s)?([ñÑáéíóúÁÉÍÓÚa-zA-Z0-9_]+))*$/.test(v) || 'Notamos algo raro, ¿Está bien escrito?',
        ],
        lastNameRules: [
          v => !!v || 'Apellido requerido',
          v => /^[ñÑáéíóúÁÉÍÓÚaa-zA-Z0-9_]+((\s)?([ñÑáéíóúÁÉÍÓÚa-zA-Z0-9_]+))*$/.test(v) || 'Notamos algo raro, ¿Está bien escrito?',
        ],
        phoneRules: [
          v => !!v || 'Aquí va el numero con el que se registrara la cuenta',
          v => v && v.length === 13 && /^[0-9]{13}$/.test(v) || "El numero tiene que ser de 13 digitos",
        ],
        emailRules: [
          v => !!v || 'Correo requerido',
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Notamos algo raro, ¿Está bien escrito?',
        ],
      }
  },
  components: {
    NavBar,
    SystemCardCount,
    ChangeRanch,
    BackButton
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    },
    numberOfAnimals() {
      if(this.$store.getters.getAnimals.length < 10){
        return "00"+this.$store.getters.getAnimals.length;
      } else if(this.$store.getters.getAnimals.length < 100){
          return "0"+this.$store.getters.getAnimals.length;
      } else if(this.$store.getters.getAnimals.length >= 100){
          return this.$store.getters.getAnimals.length;
      }
      return 0
    }
  },
  methods: {
    activateEdit(){
      this.editActive = false
      this.saveActive = true
    },
    openSectionOnboarding(section){
      if(this.section === 'DashHome'){
        this.editActive = true
        this.saveActive = false
        EventBus.$emit('openSectionOnboarding', section);
      }else{
         this.editActive = true
        this.saveActive = false
        EventBus.$emit('openSectionOnboarding', section);
      }
    },
    saveUserInformation() {
      this.userSaved = false;
    },
    openSendPasswordEmail(){
      if(this.saveActive == true){
        this.$store.dispatch('sendPasswordReset');
        this.passwordSend = true;
      }
    },
    openPageUserAdd() {
      this.$router.push({name: 'UserAdd'})
    },
    openPageUserPlan() {
      this.$router.push({name: 'UserPlan'})
    },
    openPageUserType() {
      this.$router.push({name: 'UserType'})
    },
    sendPasswordEmail(){
      this.passwordSend = false;
    }
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/BaseStyle.css';
  @import '../style/UserProfile.css';
</style>
